export const libraryCopy = {
  title: "生产资料库",
  subtitle: "个人资料相互隔离；团队共享内容需先加入个人库后使用。",
  close: "关闭资料库",
  assets: "我的素材",
  templates: "我的模板",
  shared: "团队共享",
  trash: "回收站",
  loading: "正在加载资料库…",
  loadFailed: "资料库加载失败，请检查网络后重试。",
  retry: "重试",
  emptyAssets: "还没有个人素材。可先从画布上传，或从团队共享加入。",
  emptyTemplates: "还没有个人提示词模板。",
  emptyShared: "团队暂时没有共享内容。",
  emptyTrash: "回收站为空。",
  publish: "共享到团队",
  withdraw: "撤回共享",
  administratorWithdraw: "管理员下架",
  addToCanvas: "添加到画布",
  applyToSelectedSeedance: "应用到当前 Seedance",
  importAsset: "加入我的素材",
  importPrompt: "加入我的模板",
  trashAction: "移入回收站",
  restore: "恢复",
  createTemplate: "新增模板",
  editTemplate: "编辑模板",
  saveTemplateChanges: "保存修改",
  cancelEdit: "取消",
  templateTitle: "模板名称",
  templateContent: "提示词内容",
  saveTemplate: "保存模板",
  templateRequired: "请填写模板名称和提示词内容。",
  importedAsset: "已加入我的素材。",
  importedPrompt: "已加入我的模板。",
  published: "已共享到团队。",
  withdrawn: "共享内容已撤回。",
  movedToTrash: "已移入回收站。",
  restored: "已恢复。",
  operationFailed: "操作失败，请重试。",
  searchShared: "搜索团队共享",
  search: "搜索",
  author: "提供者",
  prompt: "提示词",
  image: "图片",
  video: "视频",
  audio: "音频"
} as const;
